import { Component,  Input } from '@angular/core';
import { Budget, BudgetRevenueShare } from '../../store/reselectors/budget.data';
import { PaymentGridData, BudgetSectionGridData } from '../../helpers/grid-helpers';
import { Dictionary } from '@ngrx/entity';
import { OnInit } from '@angular/core';
import { getGridDataFromSection, scheduleToScheduleGridData } from '../../store/reselectors/budget.reselector.helpers';
import { publicHelpers } from 'src/app/helpers/public-helpers';
import { currencyNamesById } from '../../store/reselectors/currencies.data';
import { SnapshotInfo } from 'globals/store/events.data';
import { CommonModule } from '@angular/common';
import { BudgetSectionComponent } from './budget-section.component';
import { BudgetTotalsStripComponent } from './budget-totals-strip.component';
import { FileHandlerComponent } from 'src/app/components/file-handler/file-handler.component';
import { BudgetScheduleComponent } from './budget-schedule.component';

@Component({
    selector: 'budget-revenue-share-view',
    templateUrl: './revenue-share-view.html',
    styleUrls: ['./revenue-share-view.scss'],
    standalone: true,
    imports: [CommonModule, BudgetSectionComponent, BudgetTotalsStripComponent, FileHandlerComponent, BudgetScheduleComponent],
})
export class BudgetRevenueShareViewComponent implements OnInit {
  
  @Input() info: SnapshotInfo
  @Input() budget: BudgetRevenueShare // NOTE THAT THIS SHOULD NOT BE CHANGING!  STATIC INPUT SO THIS COMPONENT SHOULD ONLY LOAD WHEN THE "BUDGET" HAS BEEN LOADED
  scheduleGridData: PaymentGridData[]
  revenueGridDatas: Dictionary<BudgetSectionGridData[]> = {}
  helpers = publicHelpers
  currencyNamesById = currencyNamesById

  ngOnInit() {
    this.budget.revenueIds.forEach(id => {
      const section = this.budget.sections[id]
      this.revenueGridDatas[id] = !section.lineItems ? [] : getGridDataFromSection(this.budget.sections[id], this.budget.currency)
    })
    if (this.budget.revenuePaymentSchedule) this.scheduleGridData = scheduleToScheduleGridData(this.budget.revenuePaymentSchedule, this.budget.totalRevenue)
  }

}